window.addEventListener('load', function() {
  if (window.location.pathname.indexOf('/prescribing-information') === -1 && this.window.location.pathname.indexOf('/bleeding-disorder-conferences-downloads') === -1) {
	
    let eventAlert = sessionStorage.getItem('eventAlert');
    if (!eventAlert) {
      
      setTimeout(() => {
      
        let eventsAlert = document.getElementById('events-alert');

        // see if popup is open
        let popup = document.getElementById('usPopup');
        if (popup && popup.classList.contains('show')) {
          // us popup is open, wait for it to close
          console.log('us popup is open');
          
          let okBtn = document.querySelector('#usPopup .btn-ok');
          okBtn.addEventListener('click', function (event) {
            setTimeout(() => {
              $('#eventPopup').modal('show');
              // if (eventsAlert) eventsAlert.classList.add('show');
            }, "1000");
            
          }, false);
          
          
        } else {
          // no us popup open, show it now
          $('#eventPopup').modal('show');
          // if (eventsAlert) eventsAlert.classList.add('show');
        }
      
      }, "500");
      
    }

    let cancelBtn = document.querySelector('#eventPopup .btn-cancel');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', function (event) {
        sessionStorage.setItem('eventAlert', true);
        $('#eventPopup').modal('hide');
      }, true);
    }
    
    let okBtn = document.querySelector('#eventPopup .btn-ok');
    if (okBtn) {
      okBtn.addEventListener('click', function (event) {
        sessionStorage.setItem('eventAlert', true);
        window.location.href = '/bleeding-disorder-conferences-downloads/#singleton';
      }, true);
    }

	}
	
});
